import { createPrefetchableAsyncPaginatedDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getFirstPageData, getNextPageData } from './api';

export const {
	Context: TopicPagePaginatedVictoriousPetitionsDataContext,
	Provider: TopicPagePaginatedVictoriousPetitionsDataContextProvider,
	useContext: useTopicPagePaginatedVictoriousPetitionsData,
	useAsyncData: useTopicPagePaginatedVictoriousPetitionsDataFromApi,
	prefetchAsyncData: prefetchTopicPagePaginatedVictoriousPetitionsDataFromApi,
} = createPrefetchableAsyncPaginatedDataContext({
	name: 'TopicPagePaginatedVictoriousPetitionsDataContext',
	dataProperty: 'victoriousPetitionsPaginatedData',
	getFirstPageData,
	getNextPageData,
	getUniqueId: (slug) => slug,
	hookDeps: (slug) => [slug],
	errorHandler: pageDataErrorHandler(),
});
